import axios from "axios";

const basePath = "/web-api/checkouts";

export const send = (payload, config = {}) => {
  return axios.post(basePath + "/compute-coupon", payload, config);
};

export default {
  send
};
